var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-responsive", staticStyle: { "max-height": "300px" } },
    [
      _c("table", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.items, function(item, index) {
              return _c("tr-item-visita", {
                key: index,
                tag: "tr",
                attrs: { index: index, editable: _vm.editable },
                on: { eliminar: _vm.eliminar },
                model: {
                  value: _vm.items[index],
                  callback: function($$v) {
                    _vm.$set(_vm.items, index, $$v)
                  },
                  expression: "items[index]"
                }
              })
            }),
            _vm._v(" "),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.items.length === 0,
                    expression: "items.length === 0"
                  }
                ]
              },
              [_vm._m(1)]
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "25%" } }, [_vm._v("Código de barra")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "50%" } }, [_vm._v("Ítem")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "15%" } }, [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_c("div")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("strong", [_vm._v("No se ha agregado ítems.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cc5d854", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cc5d854","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/ItemsVisitas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7cc5d854","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/ItemsVisitas.vue
// module chunks = 0